import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const CompanyList = () => {
  const [page, setPage] = useState(1);
  const [select, setSelect] = useState(0);
  const [companyData, setCompanyData] = useState([]);
  const [floorTab, setFloorTab] = useState('ALL'); // ✅ 층수 탭 상태
  const navigate = useNavigate();
  const location = useLocation();
  const pageSize = 9; // ✅ 2 x 4

  // ✅ 전부 가져와서 프론트에서 층/페이지 필터
  useEffect(() => {
    axios
      .get(`https://ciuc.or.kr:8443/api/get/company_list?page=1&pageSize=9999`)
      .then((response) => {
        setCompanyData(response.data.data || []);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const handleSelect = (num) => {
    setSelect((prev) => (prev === num ? 0 : num));
  };

  const handlePage = (num) => {
    setPage(num);
  };

  const handlePrevPage = () => {
    setPage((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const handleNextPage = (totalPages) => {
    setPage((prev) => (prev < totalPages ? prev + 1 : prev));
  };

  const moveBoard = (cate) => {
    navigate(`/board/${cate}`, { state: { cate } });
  };

  const movePage = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  // ✅ 층수 탭 정의
  const floorTabs = [
    { key: 'ALL', label: '전체' },
    { key: '1', label: '1층' },
    { key: '2', label: '2층' },
    { key: '3', label: '3층' },
    { key: '4', label: '4층' },
    { key: '5', label: '5층' },
  ];

  const handleFloorTabChange = (key) => {
    setFloorTab(key);
    setPage(1); // 탭 바꾸면 1페이지로
  };

  // ✅ 층수 필터링 (room 101 → 1, 204 → 2, ...)
  const filteredCompanyData =
    floorTab === 'ALL'
      ? companyData
      : companyData.filter((company) => {
          if (!company.room) return false;
          const roomStr = String(company.room).trim();
          if (!roomStr) return false;
          const first = roomStr.charAt(0);
          return first === floorTab;
        });

  // ✅ 페이지네이션 계산
  const totalPages = filteredCompanyData.length === 0 ? 1 : Math.ceil(filteredCompanyData.length / pageSize);

  const startIndex = (page - 1) * pageSize;
  const currentPageData = filteredCompanyData.slice(startIndex, startIndex + pageSize);

  return (
    <div className="sub_wrap board">
      <div className="sub_back">
        {/* 상단 배너 */}
        <div className="sub_banner_area business-field">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}기업연구동{' > '}입주기업현황
            </div>
            <div className="banner_main_text">입주기업현황</div>
          </div>
        </div>

        {/* 상단 네비게이션 */}
        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">기업연구동</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => moveBoard('notice')}>
                  알림 및 소식
                </div>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  사업분야
                </div>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  기업연구동
                </div>
                <div className="select_row" onClick={() => movePage('/meetingroom')}>
                  보유시설
                </div>
                <div className="select_row" onClick={() => movePage('/vision')}>
                  융합원소개
                </div>
              </div>
            </div>

            <div className="navi_box" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">입주기업현황</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  입주안내
                </div>
                <div className="select_row" onClick={() => movePage('/floor')}>
                  층별안내
                </div>
                <div className="select_row" onClick={() => movePage('/company')}>
                  입주기업현황
                </div>
                <div className="select_row" onClick={() => moveBoard('inquiry')}>
                  입주문의
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 메인 영역 */}
        <div className="sub_main_area board">
          {/* 왼쪽 고정 사이드 메뉴 */}
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">
              {' '}
              <div className="center_box">
                <span>기업연구동</span>
                <div className="center_line"></div>
              </div>
            </div>
            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/inquiryinfo')}`} onClick={() => movePage('/inquiryinfo')}>
                <span>입주안내</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/floor')}`} onClick={() => movePage('/floor')}>
                <span>층별안내</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/company')}`} onClick={() => movePage('/company')}>
                <span>입주기업 현황</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li
                className={`intro_aside_item ${isActive('/board/inquiry')}`}
                onClick={() => movePage('/board/inquiry')}
              >
                <span>입주문의</span>
                <span className="aside_arrow">&gt;</span>
              </li>
            </ul>
          </aside>

          {/* 오른쪽 내용 영역 */}
          <div className="board_container-sub">
            {/* 제목 + 현재 경로 */}
            <div className="board_path_box">
              <div className="path_title">입주기업 현황</div>
              <div className="path_navi">
                <span className="home_icon_small">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                    <path d="M4 11.5L12 4l8 7.5V20a1 1 0 0 1-1 1h-5v-5h-4v5H5a1 1 0 0 1-1-1v-8.5z" fill="#999999" />
                    <path
                      d="M2.5 12L12 3l9.5 9"
                      fill="none"
                      stroke="#cccccc"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="path_arrow">&gt;</span>
                <span>기업연구동</span>
                <span className="path_arrow">&gt;</span>
                <span className="current">입주기업 현황</span>
              </div>
            </div>

            <div className="list_area">
              <div className="list_box company">
                {/* ✅ 층수 탭 (이 위치 기준으로 SCSS 작성) */}
                <div className="company_tab_bar">
                  {floorTabs.map((tab) => (
                    <button
                      key={tab.key}
                      type="button"
                      className={`company_tab ${floorTab === tab.key ? 'active' : ''}`}
                      onClick={() => handleFloorTabChange(tab.key)}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>

                {/* 카드 그리드 */}
                <div className="company_card_grid">
                  {currentPageData.map((company) => (
                    <div className="company_card" key={company.idx}>
                      <div className="company_card_inner">
                        {/* ✅ 상단 로고 : 중앙 정렬, 고정 영역 */}
                        <div className="company_logo_wrap">
                          {company.img1 ? (
                            <img
                              className="company_logo_img"
                              src={`https://ciuc.or.kr:8443/uploads/${company.img1}`}
                              alt={company.name || 'company logo'}
                            />
                          ) : (
                            <div className="company_logo_fallback">{company.name?.[0] || 'C'}</div>
                          )}
                        </div>

                        {/* 내용 영역 */}
                        <div className="company_content">
                          <div className="company_header_row">
                            <div className="company_name">{company.name}</div>
                            <div className="company_badge_row">
                              {company.sectors && <span className="company_badge type">{company.sectors}</span>}
                              {company.room && <span className="company_badge room">{company.room}호</span>}
                            </div>
                          </div>

                          <div className="company_body_row">
                            {company.sectors && (
                              <div className="company_info_row">
                                <span className="company_info_label">업종</span>
                                <span className="company_info_value">{company.sectors}</span>
                              </div>
                            )}
                            {company.room && (
                              <div className="company_info_row">
                                <span className="company_info_label">호실</span>
                                <span className="company_info_value">{company.room}</span>
                              </div>
                            )}
                            <div className="company_info_row">
                              <span className="company_info_label">홈페이지</span>
                              {company.homepage ? (
                                <a
                                  href={
                                    company.homepage.startsWith('http')
                                      ? company.homepage
                                      : `https://${company.homepage}`
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                  className="company_info_value company_link"
                                >
                                  {company.homepage}
                                </a>
                              ) : (
                                <span className="company_info_value muted">-</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  {filteredCompanyData.length === 0 && (
                    <div className="company_empty_text">해당 조건에 맞는 입주기업이 없습니다.</div>
                  )}
                </div>
              </div>

              {/* 페이지네이션 */}
              <div className="pagination_box">
                <div className={`arrow_btn ${page === 1 && 'disabled'}`} onClick={handlePrevPage}>
                  {'<'}
                </div>
                {Array.from({ length: totalPages }).map((_, index) => (
                  <div
                    key={index + 1}
                    className={`page_number ${page === index + 1 && 'active'}`}
                    onClick={() => handlePage(index + 1)}
                  >
                    {index + 1}
                  </div>
                ))}
                <div
                  className={`arrow_btn ${page === totalPages && 'disabled'}`}
                  onClick={() => handleNextPage(totalPages)}
                >
                  {'>'}
                </div>
              </div>
            </div>
          </div>
          {/* board_container-sub 끝 */}
        </div>
        {/* sub_main_area 끝 */}
      </div>
    </div>
  );
};

export default CompanyList;
